import { createContext } from 'react'
import { ConnectedDeploymentsProviderState } from './ConnectedDeploymentsProvider.types';

export const ConnectedDeploymentsProviderContext = createContext<ConnectedDeploymentsProviderState | undefined>(undefined);